function wrapElements(elements, wrapperTag) {
  if (!elements || elements.length < 2) {
    throw new Error('You must provide at least two elements to wrap.');
  }
  const wrapper = document.createElement(wrapperTag);
  const parent = elements[0].parentNode;
  parent.insertBefore(wrapper, elements[0]);
  elements.forEach((el) => wrapper.appendChild(el));

  return wrapper;
}

class MakeASet extends HTMLElement {
  constructor() {
    super();
    const formId = this.closest('form').getAttribute('id');
    if (formId) {
      document.querySelector('button.addtocart')?.setAttribute('form', formId);
    }
    document.body.appendChild(this);
  }
  connectedCallback() {
    this.variantWrapper = this.querySelector('.variant-wrapper');
    this.buttonWrapper = this.querySelector('.button-wrapper');
    this.priceWrapper = this.querySelector('.price-wrapper');
    this.previewWrapper = this.querySelector('.preview-wrapper');
    const variantSwatches = document.querySelector('.ProductForm__Variants');
    const addToCartButton = document.querySelector('.ProductForm__AddToCart');
    const priceContainer = document.querySelector('.ProductMeta__PriceList.Heading');

    if (variantSwatches) {
      let swatchCopies = variantSwatches.cloneNode(true);
      swatchCopies.querySelectorAll('.SizeSwatch').forEach((sizeSwatch) => {
        let productLabel = sizeSwatch.previousElementSibling.value;
        sizeSwatch.insertAdjacentHTML('afterend', `<span class="additional-label">${productLabel}</span>`);
        sizeSwatch.style.backgroundImage = `url(${this.querySelector('.variant-images [data-original-variant="' + productLabel + '"]')?.getAttribute('src')})`;
        sizeSwatch.removeAttribute('for');
        sizeSwatch.previousElementSibling.removeAttribute('id');
        sizeSwatch.previousElementSibling.removeAttribute('form');
        sizeSwatch.previousElementSibling.removeAttribute('data-option-value-id');
        sizeSwatch.querySelector('.SizeSwatch__strikethrough').remove();

        sizeSwatch.addEventListener('click', (ev) => {
          ev.target.parentElement.querySelector('input').click();
        });
        sizeSwatch.parentElement.querySelector('input').addEventListener('input', (ev) => {
          const inputValue = ev.target.value;
          const inputName = ev.target.getAttribute('name');
          variantSwatches.querySelector(`[name="${inputName}"][value="${inputValue}"]`)?.click();
        });
      });

      /**
       * Since the variant radios have the same name attribute as the main product section,
       * we encapsulate them in a blank form tag, so the browser will automatically scope them
       * and see them as distinct from the originals
       */
      let blankForm = document.createElement('form');
      blankForm.appendChild(swatchCopies);
      this.variantWrapper.appendChild(blankForm);

      variantSwatches.querySelectorAll('.SizeSwatch__Radio').forEach((swatchRadio) => {
        swatchRadio.addEventListener('input', (ev) => {
          if (ev.target.checked) {
            const inputValue = ev.target.value;
            const inputName = ev.target.getAttribute('name');
            this.querySelector(`[name="${inputName}"][value='${inputValue}']`).click();
          }
        });
      });

      this.querySelector('variant-selects').removeAttribute('hidden');
    }
    if (addToCartButton) {
      this.createSetButton = document.querySelector('[create-your-set]');
      addToCartButton.before(this.createSetButton);
      addToCartButton.textContent = this.dataset.translationAddToCart;
      this.buttonWrapper.appendChild(addToCartButton.cloneNode(true));
      addToCartButton.setAttribute('hidden', true);

      let cloneButton = this.buttonWrapper.querySelector('button');

      cloneButton.setAttribute('create-your-set-clone-add', true);
      cloneButton.setAttribute('type', 'button');
      cloneButton.removeAttribute('form');
      cloneButton.removeAttribute('data-action');
      cloneButton.classList.add('Button--primary');
      cloneButton.classList.remove('addtocart', 'ProductForm__AddToCart', 'button--secondary');
      cloneButton.addEventListener('click', (ev) => {
        addToCartButton.click();
      });

      this.createSetButton.addEventListener('click', (ev) => {
        this.updatePreview();
      });
    }
    if (priceContainer) {
      this.priceWrapper.appendChild(priceContainer.cloneNode(true));
    }

    document.addEventListener('update:product:prices', (ev) => {
      if (priceContainer) {
        this.priceWrapper.innerHTML = '';
        this.priceWrapper.appendChild(priceContainer.cloneNode(true));
      }
    });

    this.querySelectorAll('input[type=radio]').forEach((el) => {
      el.addEventListener('input', (ev) => {
        this.updatePreview();
      });
    });

    this.addEventListener('click', (ev) => {
      if (ev.target.nodeName === 'MAKE-A-SET') {
        closeDrawer();
      }
    });
  }

  updatePreview() {
    let option1 = document.querySelector('[name="option-1"]:checked').value;
    let option2 = document.querySelector('[name="option-2"]:checked').value;
    let selector = `[data-option-1="${option1}"][data-option-2="${option2}"]`;

    if (this.previewWrapper.innerHTML === '') {
      this.previewWrapper.insertAdjacentHTML(
        'afterbegin',
        `<img src="${this.querySelector(selector).getAttribute('src')}" />`,
      );
    } else {
      this.previewWrapper.querySelector('img').setAttribute('src', this.querySelector(selector).getAttribute('src'));
    }
  }
}

customElements.define('make-a-set', MakeASet);
